import { useEffect, useState } from 'react'
import LeftSidebar from '../components/dashbaord/LeftSidebar'
import TopBar from '../components/dashbaord/TopBar'
import LoadingSpinnerComponent from '../components/LoadingSpinner'
import Breadcrumb from '../components/common/Breadcrumb'
import QuickNav from '../components/common/QuickNav'
import { Outlet, useLocation } from 'react-router-dom'
import WebSocketComponent from '../services/Helpers/WebSocketHelper';
import { useMyContext } from '../context/MyContext';

export default function MainLayout() {
  const { loading } = useMyContext();
  const [leftSide, setLeftSide] = useState(false);
  const showLeftSide = () => {
    setLeftSide(!leftSide)
  }
  const [expanded, setExpanded] = useState(true);
  const [userManuallyExpanded, setUserManuallyExpanded] = useState(false);
  const pathname = useLocation();
  const isCreateStrategiesPage = pathname.pathname === '/create-strategies';
  
  useEffect(() => {
    let scroll_body = document.querySelector('.dashboard-main');
    if (scroll_body) {
      scroll_body.scrollTo(0, 0)
    }
  }, [pathname])
  
  // Auto-collapse sidebar when on create-strategies page (only if user hasn't manually expanded)
  useEffect(() => {
    if (isCreateStrategiesPage && !userManuallyExpanded) {
      setExpanded(false);
    }
  }, [isCreateStrategiesPage, userManuallyExpanded])
  
  const handleExpandedChange = (newExpanded) => {
    setExpanded(newExpanded);
    if (newExpanded) {
      setUserManuallyExpanded(true);
    }
  }
  
  return (
    <div className='container-fluid' style={{
      padding: "0px"
    }}>
      {loading && <LoadingSpinnerComponent />}
      <div className={`${expanded ? 'dashboard' : 'dashboard- dashboard-expanded'} d-flex flex-wrap ${isCreateStrategiesPage ? 'strategy-edit-mode' : ''}`}>
        <div className={`dashboard-left vh-100 ${leftSide && 'showSidebar'}`}>
          <LeftSidebar onClick={() => showLeftSide()} expanded={expanded} setExpanded={handleExpandedChange} />
        </div>
        <div className="dashboard-right">
          <TopBar onClick={() => showLeftSide()} expanded={expanded} setExpanded={handleExpandedChange} />
          <WebSocketComponent />
          <Breadcrumb />
          <div className="dashboard-main">
            <Outlet />
          </div>
          <QuickNav />
        </div>
      </div>
    </div>
  )
}
